import { useSyncExternalStore } from 'react';
let state = { bulkMode: false, selectedIds: new Set() };
const listeners = new Set();
function setState(next) {
    state = next;
    for (const l of listeners)
        l();
}
export const bulkSelection = {
    subscribe(cb) {
        listeners.add(cb);
        return () => listeners.delete(cb);
    },
    getSnapshot() {
        return state;
    },
    enter() {
        if (!state.bulkMode)
            setState({ bulkMode: true, selectedIds: state.selectedIds });
    },
    /** Exit bulk mode and drop the selection so re-entering starts clean. */
    exit() {
        setState({ bulkMode: false, selectedIds: new Set() });
    },
    /**
     * Reset to the empty/closed state. Called on an authenticated-identity change
     * (logout / operator swap) so a module-scoped selection never bleeds across
     * sessions on a shared SPA instance. A no-op when already empty (avoids a
     * spurious notify on the common same-identity refetch).
     */
    reset() {
        if (state.bulkMode || state.selectedIds.size > 0) {
            setState({ bulkMode: false, selectedIds: new Set() });
        }
    },
    clear() {
        setState({ bulkMode: state.bulkMode, selectedIds: new Set() });
    },
    toggle(id) {
        const selectedIds = new Set(state.selectedIds);
        if (selectedIds.has(id))
            selectedIds.delete(id);
        else
            selectedIds.add(id);
        setState({ bulkMode: state.bulkMode, selectedIds });
    },
    selectAll(ids) {
        setState({ bulkMode: state.bulkMode, selectedIds: new Set(ids) });
    },
};
/** Subscribe a component to the shared bulk-selection state. */
export function useBulkSelection() {
    return useSyncExternalStore(bulkSelection.subscribe, bulkSelection.getSnapshot);
}
//# sourceMappingURL=use-bulk-selection.js.map